export default __webpack_public_path__ + "static/O0150-2f56b6e6af375e02b5cb54e076222e19.png";